(function () {
  'use strict';

  function partnerFromUrl(url) {
    var u = (url || '').toLowerCase();
    if (u.indexOf('addrevenue.io') !== -1) return 'Dogman';
    if (u.indexOf('zoose.sjv.io') !== -1) return 'ZOO.se';
    if (u.indexOf('firstvet') !== -1) return 'FirstVet';
    if (u.indexOf('vetapotek') !== -1) return 'VetApotek';
    if (u.indexOf('vetapet') !== -1) return 'VetaPet';
    if (u.indexOf('hundexperten') !== -1) return 'Hundexperten';
    if (u.indexOf('buddy') !== -1) return 'Buddy';
    if (u.indexOf('petgood') !== -1) return 'Petgood';
    if (u.indexOf('fritid') !== -1 || u.indexOf('frilufts') !== -1) return 'Fritid & Vildmark';
    if (u.indexOf('goingoutdoor') !== -1) return 'Goingoutdoor';
    return 'Affiliate';
  }

  function isAffiliate(url) {
    if (!url) return false;
    return /addrevenue\.io|sjv\.io|awin1\.com|adtraction\.com|tradedoubler\.com|partner-ads\.com|firstvet|vetapotek|vetapet|hundexperten|buddy|petgood|goingoutdoor/i.test(url);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !isAffiliate(a.href)) return;

    var data = {
      event: 'affiliate_click',
      partner: partnerFromUrl(a.href),
      link_text: (a.textContent || '').trim().slice(0, 120),
      page_path: location.pathname,
      destination_host: (function(){try{return new URL(a.href).hostname}catch(e){return ''}})(),
      button_position: Array.prototype.indexOf.call(document.querySelectorAll('a[href]'), a) + 1
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('affiliate_click', data);
      }
    } catch (err) {}
  }, true);
})();
